import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useShop } from '../context/ShopContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { cartCount, setIsCartOpen } = useShop();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Capsule 01', path: '/collection' },
    { name: 'Lookbook', path: '/lookbook' },
    { name: 'Info', path: '/info' }
  ];

  return (
    <>
      <motion.nav 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled || mobileMenuOpen ? 'bg-bone/95 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6 md:py-8'}`}
      >
        <div className="container mx-auto px-6 flex justify-between items-center">
          <div className="hidden md:flex gap-8 text-[10px] uppercase tracking-[0.2em] font-bold w-1/3">
            {navLinks.slice(0, 2).map((link) => (
              <Link 
                key={link.path} 
                to={link.path} 
                className={`hover:text-crimson transition-colors ${location.pathname === link.path ? 'text-crimson' : ''}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
          
          <button 
            className="md:hidden z-50 text-graphite p-2 -ml-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <SafeIcon icon={mobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-xl" />
          </button>
          
          <div className="w-1/3 flex justify-center">
            <Link to="/" className="text-2xl md:text-3xl font-bold tracking-tighter uppercase z-50 hover:text-crimson transition-colors">
              ArcLoom
            </Link>
          </div>
          
          <div className="flex gap-6 md:gap-8 text-[10px] uppercase tracking-[0.2em] font-bold w-1/3 justify-end items-center">
            <Link to="/info" className="hover:text-crimson transition-colors hidden md:block">Info</Link>
            <button 
              onClick={() => setIsCartOpen(true)}
              className="hover:text-crimson transition-colors flex items-center gap-2 z-50 group"
            >
              BAG 
              <span className="text-crimson group-hover:scale-110 transition-transform">[{cartCount}]</span>
            </button>
          </div>
        </div>
      </motion.nav>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: '-100%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-100%' }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="fixed inset-0 bg-bone z-40 flex flex-col justify-center px-6 pt-20 pb-10"
          >
            <div className="flex flex-col gap-12 text-center">
              {navLinks.map((link, i) => (
                <motion.div
                  key={link.path}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 + (i * 0.1) }}
                >
                  <Link to={link.path} className={`text-5xl uppercase tracking-tighter font-medium ${location.pathname === link.path ? 'text-crimson' : 'text-graphite'}`}>
                    {link.name}
                  </Link>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}